import { render, staticRenderFns } from "./updateProfile.vue?vue&type=template&id=40a677ba&scoped=true"
import script from "./updateProfile.vue?vue&type=script&lang=js"
export * from "./updateProfile.vue?vue&type=script&lang=js"
import style0 from "./updateProfile.vue?vue&type=style&index=0&id=40a677ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a677ba",
  null
  
)

export default component.exports